import React, { FC } from 'react';

import { statFormatter } from '@nhl/formatter-utilities';
import { IdEnums } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { PlayerStatAbbrev, PlayerStatNames } from '~/core/enums';
import { Team } from '~/core/types';

import { TeamGoalieTotals } from '../../../../types';
import StatDisplay from '../StatDisplay/StatDisplay';

import { LogoContainer, TeamStatsContainer } from './styles';

type TeamStatProps = {
    gameType: IdEnums.GameType;
    team: Team;
    teamTotals?: TeamGoalieTotals;
};

const TeamStats: FC<TeamStatProps> = ({ gameType, team, teamTotals }) => {
    const hasData = teamTotals?.gaa || teamTotals?.shutouts || teamTotals?.savePctg || teamTotals?.record;

    return (
        <TeamStatsContainer>
            <LogoContainer>
                <TeamDisplay logoUrlOverride={team.logo} team={{ triCode: team.abbrev }} displayName={false} />
            </LogoContainer>
            {hasData && (
                <>
                    <StatDisplay
                        isTeam
                        messageAbbrev={
                            gameType === IdEnums.GameType.playoffs
                                ? PlayerStatAbbrev.playoffRecord
                                : PlayerStatAbbrev.record
                        }
                        messageName={PlayerStatNames.record}
                        value={teamTotals?.record}
                    />
                    <StatDisplay
                        isTeam
                        messageAbbrev={PlayerStatAbbrev.goalsAgainstAvg}
                        messageName={PlayerStatNames.goalsAgainstAvg}
                        value={statFormatter.displayValueAs('goalsAgainstAverage')(
                            teamTotals?.gaa,
                            teamTotals?.gamesPlayed && teamTotals.gamesPlayed > 0
                        )}
                    />
                    <StatDisplay
                        isTeam
                        messageAbbrev={PlayerStatAbbrev.savePctg}
                        messageName={PlayerStatNames.savePctg}
                        value={statFormatter.displayValueAs('savePercentage')(teamTotals?.savePctg)}
                    />
                    <StatDisplay
                        isTeam
                        messageAbbrev={PlayerStatAbbrev.shutouts}
                        messageName={PlayerStatNames.shutouts}
                        value={teamTotals?.shutouts}
                    />
                </>
            )}
        </TeamStatsContainer>
    );
};

export default TeamStats;
